import { CalendarEvent } from 'app/events/events';
import { HallOfFames } from 'app/hall-of-fame/hall-of-fame';

export interface Category {
    categoryId: number;
    name: string;
    active: boolean;
    dateCreated: string | Date;
    dateUpdated: string | Date;
    updatedBySapid: string | number;
}

export interface CategoryHOF {
    hofcategoryId: number;
    categoryName: string;
    hofcategoryHallOfFame?: any[]; // Type HofcategoryHallOfFame[]
}

export interface HofcategoryHallOfFame {
    hallOfFameId: number;
    hofcategoryHallOfFameId: number;
    hofcategoryId: number;
    hallOfFame?: HallOfFames;
    hofcategory?: CategoryHOF;
}

export class CategoryTags {
    name: string;
    id: number;

    constructor(name: string, id: number) {
        this.name = name;
        this.id = id;
    }
}

export class CategoryEvents {
    categoryEventId: number;
    categoryId: number;
    eventId: number;
    category?: Category;
    event?: CalendarEvent;
}
